import './login.scss';
//react
import { useForm } from 'react-hook-form';
import { useRef, useState, useEffect } from 'react';
//shared
import { MESSAGE_LOGIN } from './constants/messages';
import { SIGN_IN_BUTTON, DEFAULT_VALUES_INPUT, INPUTS_FORM } from "./constants/form_sign_in";
import { useAuth } from '../auth/auth';
import logo from '../../assets/icons/fitpal.png';
import { MuiButton } from '../shared/components/button/button';
import { SING_IN } from '../shared/graphql/login';
import { Input } from '../shared/components/input/input';
import Message from '../shared/components/message/message';
//material
import { useMutation } from '@apollo/client';
import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate, useLocation } from 'react-router-dom';
import { sendPageView } from '../shared/services/analytics'

function Login() {

    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Login");
    }, [location]);
    

    const userRememberLocal = localStorage.getItem('userRemember');
    const [isChecked, setIsChecked] = useState(userRememberLocal?true:false);
    const handleOnChangeCheckBox = () => {
        setIsChecked(!isChecked);
    };
    const navigate = useNavigate();
    let message = MESSAGE_LOGIN;
    message.open = useRef<any>(null);

    const { login } = useAuth();

    //--------------------------------------------------------------->LLamado de mutación
    const [loginProvider, { data, loading, error }] = useMutation(SING_IN);
    if (data) {
        //Redirect y guardar token usuario
        if (data.loginProvider.token) {
            login(data.loginProvider.token);
            if(data.loginProvider.typeUser === 3 || data.loginProvider.typeUser === 1){
                navigate(`/branch`);
            }else{
                navigate(`/programs`);
            }
        } else {
            setTimeout(() => {
                message.open.current.show();
            }, 500);
        }
    }
    if (error) console.log(`Submission error! ${error.message}`);
    //---------------------------------------------------------------------------------------------------->


    //Manejo de Formularios
    if(userRememberLocal){
        DEFAULT_VALUES_INPUT.username = userRememberLocal;
    }
    const methods = useForm<any>({ defaultValues: DEFAULT_VALUES_INPUT });
    const { handleSubmit, control, register } = methods;
    const onSubmit = (data: any) => {
        if (isChecked) {
            localStorage.setItem('userRemember', data.username);
        } else {
            localStorage.removeItem('userRemember');
        }
        loginProvider({ variables: data });
    }

    return (
        <div>
            <Grid container spacing={0}>
                <Grid  item display={{ xs: "none", sm: "none", md: "block" }} md={8} className='image'>
                </Grid>
                <Grid item xs={12} sm={12} md={4} container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}
                >
                    <div className='container-body-login'>
                        <div className="contain-img">
                            <img src={logo} alt="fitpal" className='logo-image' />
                        </div>

                        <Input inputData={INPUTS_FORM[0]} control={control} register={register}></Input>
                        <Input inputData={INPUTS_FORM[1]} control={control} register={register}></Input>
                    </div>
                    <FormControlLabel
                        className="input"
                        control={
                            <Checkbox
                                checked={isChecked}
                                onChange={handleOnChangeCheckBox}
                                value={isChecked} color="primary"
                            />
                        }
                        label="Recordar correo de acceso"
                    />
                    <div className='button-login'>
                        {!loading ? (
                            <MuiButton buttonData={SIGN_IN_BUTTON[0]} buttonClick={handleSubmit(onSubmit)}></MuiButton>
                        ) : (
                            <CircularProgress size={25} />
                        )}
                    </div>
                </Grid>
            </Grid>
            <Message data={message} ref={message.open} />
        </div>
    );
}

export default Login;